import { actionStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsActions";
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

headerStyles.infoGridItem = {
    width: 12,
    css: css`
        align-items: flex-end;
        @media print {
            justify-content: flex-start;
            flex-direction: row !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        flex-direction: column;
                    `,
                    null,
                    null,
                    css`
                        justify-content: flex-start;
                        > span {
                            padding-left: 0px;
                        }
                    `,
                ],
                "max",
            )}
    `,
};

headerStyles.tagText={
    css: css`
            display: flex;
            background: ${getColor("primary.main")};
            color: ${getColor("primary.contrast")};
            border-radius: 4px;
            white-space: nowrap;
            margin-right: 6px;
            margin-bottom: 6px;
            padding: 2px 6px;
            font-size: 15px;
            align-items: center;
            padding-left: 14px;
            @media print {
                display: inline-block;
            }
        `,
}


headerStyles.tagCloseText = {
    css: css`
        line-height: 12px;
        margin-left: 6px;
        cursor: pointer;
        svg{
        color: ${getColor("primary.contrast")};
        @media print{
            height:15px !important;
        }

        }
    `,
}